var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"specs"},[(_vm.items.length > 0)?_c('div',[_c('div',{staticClass:"spec-list"},_vm._l((_vm.items),function(item,index){return _c('spec',{key:index,attrs:{"useType":_vm.useType,"item":item}})}),1)]):_c('div',[_vm._v("ただいま商品を準備中です。")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-695a5085","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/Specs.vue
// module id = null
// module chunks = 